import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteRequest, getRequest, patchRequest, postRequest, ResponseDataType } from 'api';
import { Card, Row, Col, Table, TableProps, Button, Modal, Input, Space, List, InputNumber, Select, Popconfirm } from 'antd';
import { DatePicker } from 'Components';
import { toast } from 'react-toastify';
import { ROLE, checkRole } from 'constant/role'; // ✅ Thêm dòng này
import { Form } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import dayjs from 'dayjs';
interface ClassYearData {
    classYearId: number;
    className: string;
    classLevel: string;
    schoolName: string;
    schoolYear: string;
}

interface StudentData {
    studentId: number;
    name: string;
    dob: string;
    gender: number;
    studentCode: string;
    cmnd: string;
}
interface HomeroomTeacher {
    teacherId: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
}
interface SubjectTeacher {
    teacherId: number;
    customerId: number;
    gender: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
    email: string;
    address: string;
    currentStatus: number;
    contractType: number;
    schoolId: number;
}
interface IncomeSourceData {
    id: number;
    description: string;
    unitPrice: number;
    expectedUnits: number;
    actualUnits: number;
    createdDate: number[];
    updatedDate: number[];
    incomeSchoolId: number;
}
export const SubjectTeacherClassYearIncome = () => {
    const navigate = useNavigate();
    const [incomeModalVisible, setIncomeModalVisible] = useState(false);
    const [selectedStudentId, setSelectedStudentId] = useState<number | null>(null);

    const [incomeForm, setIncomeForm] = useState({
        unitType: 1,
        description: '',
        unitPrice: '',
        expectedUnits: ''
    });
    const [form] = Form.useForm();
    const [selectedIncome, setSelectedIncome] = useState<IncomeSourceData | null>(null);
    const [selectedType, setSelectedType] = useState<number | null>(null);
    const [incomeNames, setIncomeNames] = useState<string[]>([]);
    const [editForm] = Form.useForm();
    const [showEditClassModal, setShowEditClassModal] = useState(false);
    const [subjectTeachers, setSubjectTeachers] = useState<SubjectTeacher[]>([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [subjectTeacherSearchResults, setSubjectTeacherSearchResults] = useState<SubjectTeacher[]>([]);
    const [loadingSubjectSearch, setLoadingSubjectSearch] = useState(false);
    const isAdmin = checkRole(ROLE.ADMIN);
    const isAccountant = checkRole(ROLE.ACCOUNTANT);
    const [homeroomTeacher, setHomeroomTeacher] = useState<HomeroomTeacher[] | null>(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showAddTeacherModal, setShowAddTeacherModal] = useState(false);
    const [newTeacherEmail, setNewTeacherEmail] = useState('');
    const [teacherSearchResults, setTeacherSearchResults] = useState<any[]>([]);
    const [loadingTeacherSearch, setLoadingTeacherSearch] = useState(false);
    const [selectedIncomeType, setSelectedIncomeType] = useState<number | null>(null);
    const schoolId = Number(localStorage.getItem("schoolId"));

    const { classYearId } = useParams<{ classYearId: string }>();
    const [classInfo, setClassInfo] = useState<ClassYearData | null>(null);
    const [students, setStudents] = useState<StudentData[]>([]);
    const [searchResults, setSearchResults] = useState<StudentData[]>([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (classYearId) {
            fetchClassInfo(classYearId);
            fetchStudentsInClass(classYearId);
            fetchHomeroomTeacher(classYearId);
            fetchSubjectTeachers(classYearId);
        }
    }, [classYearId]);

    const fetchClassInfo = async (id: string) => {
        const response: ResponseDataType<ClassYearData> = await getRequest(`/cms/class/get-class-year-info?classYearId=${id}`);
        if (response?.code === 200 && response.info) {
            setClassInfo(response.info);
        } else {
            toast.error('Không thể tải thông tin lớp học');
        }
    };
    const fetchSubjectTeachers = async (id: string) => {
        try {
            const res: ResponseDataType<any> = await getRequest(`/cms/teacher/get-subject-teacher-by-class-year?classYearId=${id}`);
            if (res?.code === 200 && Array.isArray(res.info) && res.info.length > 0) {
                setSubjectTeachers(res.info);
            } else {
                setSubjectTeachers([]);
            }
        } catch (error) {
            toast.error("Lỗi khi tải danh sách giáo viên bộ môn");
        }
    };
    const fetchHomeroomTeacher = async (id: string) => {
        const response: ResponseDataType<any> = await getRequest(`/cms/teacher/get-homeroom-teacher-by-class-year?classYearId=${id}`);
        if (response?.code === 200 && Array.isArray(response.info) && response.info.length > 0) {
            setHomeroomTeacher(response.info);
        } else {
            setHomeroomTeacher(null);
        }
    };
    const handleAddSubjectTeacher = async (teacherId: number) => {
        try {
            const res = await postRequest(`/cms/class/${classYearId}/add-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã thêm giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
                setShowAddModal(false);
                // setSubjectTeacherSearchResults([]);
            } else {
                toast.error(res?.msg || "Thêm thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API thêm giáo viên");
        }
    };
    const handleAddTeacher = async (teacherId: number) => {
        const response = await postRequest(
            `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
            { teacherId }
        );

        if (response?.code === 200) {
            toast.success('Đã thêm giáo viên chủ nhiệm');
            setShowAddTeacherModal(false);
            fetchHomeroomTeacher(classYearId!);
        } else {
            toast.error(response?.msg || 'Thêm giáo viên thất bại');
        }
    };
    const handleDeleteTeacher = async (teacherId: number) => {
        try {
            const res = await deleteRequest(`/cms/class/${classYearId}/delete-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã xóa giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
            } else {
                toast.error(res?.msg || "Xóa thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API xóa giáo viên");
        }
    };



    const fetchStudentsInClass = async (id: string) => {
        const response: ResponseDataType<{ list: StudentData[] }> = await getRequest(`/cms/student/get-students-by-class-year?classYearId=${id}`);
        if (response?.code === 200 && response.info && Array.isArray(response.info.list)) {
            setStudents(response.info.list);
        } else {
            setStudents([]);
            toast.error('Không thể tải danh sách học sinh');
        }
    };
    const handleCreateIncome = async () => {
        try {
            const values = await form.validateFields();
            if (!classYearId) return;
            const valuess = await form.validateFields();
            const selectedMonthYear = valuess.monthYear;
            const payload = {
                ...values,
                month: selectedMonthYear.month() + 1,
                year: selectedMonthYear.year(),
                actualUnits: values.expectedUnits,
                status: 0,
            };

            const res = await postRequest(
                `/cms/accountant/income-student-register/class-year/${classYearId}`,
                payload
            );

            if (res.code === 200) {
                toast.success("Tạo nguồn thu thành công");
                setIncomeModalVisible(false);
                form.resetFields();

                // Gọi lại API để reload danh sách sau khi thêm
                fetchStudentsInClass?.(classYearId);
            } else {
                toast.error(res.msg || "Tạo nguồn thu thất bại");
            }
        } catch (error) {
            toast.error("Vui lòng kiểm tra lại thông tin");
        }
    };


    const handleSearchTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingTeacherSearch(true);
        const response: ResponseDataType<{ teacherId: number; fullName: string }[]> =
            await getRequest(`/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`);

        if (response?.code === 200 && Array.isArray(response.info)) {
            setTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setTeacherSearchResults([]);
        }
        setLoadingTeacherSearch(false);
    };


    const handleSearchSubjectTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingSubjectSearch(true);

        const response: ResponseDataType<SubjectTeacher[]> = await getRequest(
            `/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`
        );

        if (response?.code === 200 && Array.isArray(response.info)) {
            setSubjectTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setSubjectTeacherSearchResults([]);
        }

        setLoadingSubjectSearch(false);
    };





    const handleUpdateHomeroomTeacher = async (teacherId: number) => {
        try {
            if (Array.isArray(homeroomTeacher) && homeroomTeacher.length > 0) {
                for (const teacher of homeroomTeacher) {
                    const deleteResponse = await deleteRequest(
                        `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                        { teacherId: teacher.teacherId }
                    );

                    if (deleteResponse?.code !== 200) {
                        toast.error(deleteResponse?.msg || 'Không thể xoá giáo viên cũ');
                        return;
                    }
                }
            }

            const addResponse = await postRequest(
                `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
                { teacherId }
            );

            if (addResponse?.code === 200) {
                toast.success('Cập nhật giáo viên chủ nhiệm thành công');
                setShowUpdateModal(false);
                fetchHomeroomTeacher(classYearId!);
            } else {
                toast.error(addResponse?.msg || 'Không thể thêm giáo viên mới');
            }
        } catch (err) {
            toast.error('Đã xảy ra lỗi khi cập nhật giáo viên chủ nhiệm');
        }
    };


    const handleDeleteStudent = async (studentId: number) => {
        const response: ResponseDataType<{}> = await deleteRequest(`/cms/class/${classYearId}/delete-studentClassYear`, { studentId });

        if (response?.code === 200) {
            toast.success('Xoá học sinh thành công');
            fetchStudentsInClass(classYearId!);
        } else {
            toast.error(response?.msg || 'Xoá học sinh thất bại');
        }
    };

    const handleSearchByCMND = async (cmnd: string) => {
        if (!cmnd || cmnd.length < 3) {
            toast.warning('Vui lòng nhập CCCD hợp lệ');
            return;
        }

        setLoadingSearch(true);
        const response: ResponseDataType<StudentData> = await getRequest(`/cms/student/get-student-by-cmnd?cmnd=${cmnd}`);
        if (response?.code === 200 && response.info) {
            setSearchResults([response.info]);
        } else {
            setSearchResults([]);
            toast.error(response?.msg || 'Không tìm thấy học sinh');
        }
        setLoadingSearch(false);
    };
    const handleIncomeTypeChange = (value: number) => {
        setSelectedType(value);
        setSelectedIncomeType(value);
        setIncomeNames([]);
        form.setFieldsValue({
            type: value,
            incomeName: undefined,
            incomeSchoolId: undefined,
        });
        handleTypeChange(value); // ⬅️ RẤT QUAN TRỌNG
    };
    const handleTypeChange = async (type: number) => {
        setIncomeNames([]);
        try {
            const res = await getRequest(`/cms/accountant/income-school/get-income-school-by-school-and-type?schoolId=${schoolId}&type=${type}`);
            if (res.code === 200 && Array.isArray(res.info)) {
                setIncomeNames(res.info.map((item: any) => item.name));
            } else {
                setIncomeNames([]);
                toast.error("Không thể tải danh sách tên nguồn thu");
            }
        } catch (e) {
            setIncomeNames([]);
            toast.error("Lỗi khi tải tên nguồn thu");
        }
    };
    const handleAddStudent = async (studentId: number) => {
        const response = await postRequest(`/cms/class/${classYearId}/add-student-to-class-year`, { studentId });

        if (response?.code === 200) {
            toast.success('Đã thêm học sinh');
            fetchStudentsInClass(classYearId!);
            setShowModal(false);
        } else {
            toast.error(response?.msg || 'Thêm học sinh thất bại');
        }
    };
    const handleNameChange = async (name: string) => {
        console.log("changed", name);


        try {
            const res = await getRequest(`/cms/accountant/income-school/get-income-school-by-name-and-school?schoolId=${schoolId}&name=${encodeURIComponent(name)}`);
            if (res.code === 200 && res.info?.id) {
                form.setFieldsValue({ incomeSchoolId: res.info.id });
            } else {
                toast.error("Không tìm thấy incomeSchoolId");
            }
        } catch (e) {
            toast.error("Lỗi khi lấy incomeSchoolId");
        }
    };
    const columns: TableProps<StudentData>['columns'] = [
        { title: 'ID', dataIndex: 'studentId', key: 'studentId', align: 'center' },
        { title: 'Họ tên', dataIndex: 'name', key: 'name', align: 'center' },
        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            align: 'center',
            render: (gender) => (gender === 1 ? 'Nam' : 'Nữ'),
        },
        { title: 'Mã học sinh', dataIndex: 'studentCode', key: 'studentCode', align: 'center' },
        { title: 'CCCD', dataIndex: 'cmnd', key: 'cmnd', align: 'center' },
        {
            title: 'Hành động',
            key: 'action',
            align: 'center',
            render: (_, record) => {
                if (isAdmin) {
                    return (
                        <Button danger onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn xoá học sinh này?',
                                okText: 'Xoá',
                                okType: 'danger',
                                cancelText: 'Hủy',
                                onOk: () => handleDeleteStudent(record.studentId),
                            });
                        }}>Xoá</Button>
                    );
                } else if (isAccountant) {
                    return (
                        <Button type="link" onClick={() => navigate(`/revenue-source/${record.studentId}/class/${classYearId}`)}>
                            Chi tiết
                        </Button>

                    );
                } else {
                    return null;
                }
            }
        },
    ];
    return (
        <div>
            <Card
                bordered={false}
                style={{
                    borderRadius: '8px',
                    border: '1px solid #f0f2f5',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    marginBottom: 16,
                }}
                bodyStyle={{ padding: '12px 16px' }}
                styles={{ body: { padding: '12px 16px' } }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 12,
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: 16 }}>Thông tin chung</h3>
                    {isAdmin && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                if (classInfo) {
                                    editForm.setFieldsValue({
                                        className: classInfo.className,
                                        classLevel: classInfo.classLevel,
                                        schoolYear: classInfo.schoolYear,
                                    });
                                    setShowEditClassModal(true);
                                }
                            }}
                        >
                            Cập nhật thông tin lớp
                        </Button>
                    )}
                </div>

                {classInfo ? (
                    <Row gutter={[16, 12]}>
                        <Col xs={24} sm={12} md={6}>
                            <strong>Trường học:</strong> {classInfo.schoolName || '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Năm học:</strong> {classInfo.schoolYear || '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Khối lớp:</strong> {classInfo.classLevel ? `Khối ${classInfo.classLevel}` : '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Tên lớp:</strong> {classInfo.className || '-'}
                        </Col>
                    </Row>
                ) : (
                    <div>Đang tải thông tin lớp...</div>
                )}
            </Card>

            <Modal
                title="Cập nhật thông tin lớp"
                open={showEditClassModal}
                onCancel={() => setShowEditClassModal(false)}
                onOk={async () => {
                    try {
                        const values = await editForm.validateFields();

                        if (!classInfo) {
                            toast.error("Không có thông tin lớp để cập nhật");
                            return;
                        }

                        const payload = {
                            ...classInfo,
                            classLevel: values.classLevel,
                            className: values.className,
                            schoolYear: values.schoolYear,
                            classYearID: Number(classYearId),
                        };

                        const result = await patchRequest(
                            "/cms/class/update-class-year",
                            payload
                        );

                        if (result?.code === 200) {
                            toast.success("Cập nhật lớp thành công");
                            setShowEditClassModal(false);
                            fetchClassInfo(classYearId!);
                        } else {
                            toast.error(result?.msg || "Cập nhật thất bại");
                        }
                    } catch (err) {
                        toast.error("Vui lòng nhập đầy đủ thông tin hợp lệ");
                    }
                }}
                okText="Lưu"
                cancelText="Hủy"
            >
                <Form form={editForm} layout="vertical">
                    <Form.Item label="Tên lớp" name="className" rules={[{ message: "Nhập tên lớp" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Khối" name="classLevel">
                        <Input placeholder="Nhập khối" />
                    </Form.Item>
                    <Form.Item label="Năm học" name="schoolYear" rules={[{ message: "Nhập năm học" }]}>
                        <Input placeholder="Ví dụ: Năm học 2025-2026" />
                    </Form.Item>
                </Form>
            </Modal>


            {/* <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Thông tin giáo viên chủ nhiệm</h3>

                    {isAdmin && (
                        <div style={{ marginBottom: 8 }}>
                            <Button type="primary" icon={<PlusOutlined />}
                                onClick={() => setShowAddTeacherModal(true)}>
                                Thêm giáo viên chủ nhiệm
                            </Button>

                        </div>
                    )}
                </div>

                <Table

                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },
                        ...(isAdmin
                            ? [
                                {
                                    title: 'Hành động',
                                    key: 'action',
                                    align: 'center' as const,
                                    render: (_: any, record: any) => (
                                        <>
                                            <Button
                                                type="link"
                                                onClick={() => {

                                                    setShowUpdateModal(true);
                                                }}
                                            >
                                                Cập nhật
                                            </Button>

                                            <Button
                                                type="link"
                                                danger
                                                onClick={() => {
                                                    Modal.confirm({
                                                        title: "Bạn có chắc chắn muốn xóa giáo viên chủ nhiệm này không?",
                                                        content: "Hành động này không thể hoàn tác.",
                                                        okText: "Xóa",
                                                        cancelText: "Hủy",
                                                        okType: "danger",

                                                        async onOk() {
                                                            if (!classYearId || !record.teacherId) {
                                                                toast.error("Thiếu classYearId hoặc teacherId");
                                                                return;
                                                            }

                                                            try {
                                                                const res = await deleteRequest(
                                                                    `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                                                                    { teacherId: record.teacherId }
                                                                );

                                                                if (res?.code === 200) {
                                                                    toast.success("Đã xóa giáo viên chủ nhiệm");
                                                                    fetchClassInfo(classYearId);
                                                                    fetchHomeroomTeacher(classYearId);
                                                                } else {
                                                                    toast.error(res?.msg || "Xóa thất bại");
                                                                }
                                                            } catch (err) {
                                                                toast.error("Lỗi khi gọi API xóa GVCN");
                                                            }
                                                        }
                                                    });
                                                }}
                                            >
                                                Xóa
                                            </Button>

                                        </>
                                    ),
                                },
                            ]
                            : []),

                    ]}


                    dataSource={Array.isArray(homeroomTeacher) ? homeroomTeacher : []}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên chủ nhiệm' }}
                />
            </div> */}


            <Modal
                title="Thêm giáo viên chủ nhiệm"
                open={showAddTeacherModal}
                onCancel={() => {
                    setShowAddTeacherModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item
                            actions={[
                                <Button type="link" onClick={() => handleAddTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email})</span>
                            </Space>
                        </List.Item>

                    )}
                />
            </Modal>
            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>Danh sách giáo viên bộ môn</h3>
                    {isAdmin && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setShowAddModal(true)}
                        >
                            Thêm giáo viên bộ môn
                        </Button>
                    )}
                </div>
                <Table
                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },

                        ...(isAdmin ? [{
                            title: 'Hành động',
                            key: 'action',

                            render: (_: any, record: SubjectTeacher) => (
                                <Button
                                    type="link"
                                    danger
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'Bạn có chắc chắn muốn xóa giáo viên này?',
                                            content: 'Hành động này không thể hoàn tác.',
                                            okText: 'Xóa',
                                            cancelText: 'Hủy',
                                            okType: 'danger',
                                            centered: true,
                                            onOk: async () => {
                                                await handleDeleteTeacher(record.teacherId);
                                            }
                                        });
                                    }}
                                >
                                    Xóa
                                </Button>
                            )
                        }] : [])

                    ]}
                    dataSource={subjectTeachers}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên bộ môn' }}
                />


            </div>


            <Modal
                title="Thêm giáo viên bộ môn"
                open={showAddModal}
                onCancel={() => {
                    setShowAddModal(false);
                    setSubjectTeacherSearchResults([]);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingSubjectSearch}
                    onSearch={handleSearchSubjectTeacherByEmail}
                />
                <List
                    dataSource={subjectTeacherSearchResults}
                    renderItem={(item: any, index) => (
                        <List.Item
                            key={index}
                            actions={[
                                <Button type="link" onClick={() => handleAddSubjectTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email || 'Chưa có email'})</span>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>
            <Modal
                title="Cập nhật giáo viên chủ nhiệm"
                open={showUpdateModal}
                onCancel={() => {
                    setShowUpdateModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleUpdateHomeroomTeacher(item.teacherId)}>Cập nhật</Button>]}>
                            <Space direction="vertical"><b>{item.fullName}</b></Space>
                        </List.Item>
                    )}
                />
            </Modal>

            {/* <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ margin: 0 }}>Danh sách học sinh</h3>
                    {isAccountant && (
                        <Button type="primary" onClick={() => setIncomeModalVisible(true)}>
                            Thêm nguồn thu cho tất cả học sinh
                        </Button>
                    )}
                    {isAdmin && (
                        <div style={{ marginTop: 16 }}>
                            <Button type="primary" icon={<PlusOutlined />}
                                onClick={() => setShowModal(true)}>Thêm học sinh</Button>
                        </div>
                    )}

                </div>
                <Table
                    columns={columns}
                    dataSource={students.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
                    rowKey="studentId"
                    pagination={false}
                    locale={{ emptyText: 'Không có học sinh nào' }}
                />

            </div> */}
            <Modal
                title="Thêm nguồn thu cho tất cả học sinh"
                open={incomeModalVisible}
                onCancel={() => setIncomeModalVisible(false)}
                onOk={handleCreateIncome}
                okText="Thêm"
                cancelText="Hủy"
            >
                <Form layout="vertical" form={form}>
                    <Form.Item name="type" label="Loại nhóm thu" rules={[{ required: true }]}>
                        <Select placeholder="Chọn loại" onChange={handleIncomeTypeChange}>
                            <Select.Option value={1}>Nhóm ăn uống</Select.Option>
                            <Select.Option value={2}>Nhóm học phí</Select.Option>
                            <Select.Option value={3}>Nhóm học theo buổi (tiết)</Select.Option>
                            <Select.Option value={4}>Nhóm chi phí khác</Select.Option>
                            <Select.Option value={5}>Nhóm thu hộ</Select.Option>
                        </Select>
                    </Form.Item>

                    {selectedIncomeType === 1 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    addonAfter="VND/ngày"
                                />
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}

                    {selectedIncomeType === 2 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                            <Form.Item label="Đơn vị tính">
                                <Select
                                    placeholder="Chọn đơn vị tính"

                                    style={{ width: '100%' }}
                                >
                                    <Select.Option value="month">Theo tháng</Select.Option>
                                    <Select.Option value="semester">Theo kỳ (nửa năm học)</Select.Option>
                                    <Select.Option value="year">Theo năm học</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}
                    {selectedIncomeType === 3 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={0} addonAfter="VND/buổi" />
                            </Form.Item>
                            <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={1} />
                            </Form.Item>
                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}{selectedIncomeType === 4 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>

                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}{selectedIncomeType === 5 && (
                        <>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                    {incomeNames.map((name) => (
                                        <Select.Option key={name} value={name}>{name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>



                            <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>

                            <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true }]}>
                                <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" />
                            </Form.Item>

                            <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                        </>
                    )}
                    {/*
                                     <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                       <Select placeholder="Chọn tên" onChange={handleNameChange}>
                                           {incomeNames.map((name) => (
                                               <Select.Option key={name} value={name}>{name}</Select.Option>
                                           ))}
                                       </Select>
                                   </Form.Item>
                                   <Form.Item name="incomeSchoolId" hidden>
                                       <Input />
                                   </Form.Item>


                                   <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                       <Input />
                                   </Form.Item>
                                   <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                       <InputNumber style={{ width: '100%' }} min={0} />
                                   </Form.Item>
                                   <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                       <InputNumber style={{ width: '100%' }} min={1} />
                                   </Form.Item>
                                   <Form.Item name="month" label="Tháng" rules={[{ required: true }]}>
                                       <Select placeholder="Chọn tháng">
                                           {[...Array(12)].map((_, i) => (
                                               <Select.Option key={i + 1} value={i + 1}>
                                                   {`Tháng ${i + 1}`}
                                               </Select.Option>
                                           ))}
                                       </Select>
                                   </Form.Item>
                                   <Form.Item name="year" label="Năm" rules={[{ required: true }]}>
                                       <DatePicker picker="year" style={{ width: '100%' }} />
                                   </Form.Item> */}
                </Form>
            </Modal>

            <Modal
                title="Tìm học sinh bằng CCCD"
                open={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập CCCD học sinh"
                    enterButton="Tìm kiếm"
                    loading={loadingSearch}
                    onSearch={handleSearchByCMND}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={searchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleAddStudent(item.studentId)}>Thêm</Button>]}>
                            <Space direction="vertical">
                                <div><b>{item.name}</b> ({item.studentCode})</div>
                                <div>{item.dob} - CCCD: {item.cmnd}</div>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    );
};
